import React from "react";
import SupportSpoVlaMedewerkerForm from "./SupportSpoVlaMedewerkerForm";
import SupportSpoVlaMedewerkerPageHelper from "./SupportSpoVlaMedewerkerPageHelper";
import AutoBindComponent from "../../common/AutoBindComponent";
import redirector from "../../../util/redirector";
import { bindActionCreators } from "redux";
import * as layoutActions from "../../../actions/e-loketLayoutActions";
import { throwException } from "../../../actions/exceptionActions";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { AccountTypes } from "../../../constants/DomainConstants";

class SupportSpoVlaMedewerkerPage extends AutoBindComponent {
    constructor(props, context) {
        super(props, context, true);

        this.state = {
            accountId: null,
            organisatieType: AccountTypes.ORGANISATOR
        };

        this.pageHelper = new SupportSpoVlaMedewerkerPageHelper(this, redirector);
    }

    componentDidMount = () => {
        super.componentDidMount();
        this.props.loadLayout();
    };

    handleOnAccountIdChange = (event) => this.pageHelper.accountIdChange(event);
    handleOnOrganisatieTypeChange = (event) => this.pageHelper.organisatieTypeChange(event);
    handleOnSearch = (accountId, organisatieType) => this.pageHelper.search(accountId, organisatieType);

    render() {
        return (
            <SupportSpoVlaMedewerkerForm
                accountId={this.state.accountId}
                organisatieType={this.state.organisatieType}
                onAccountIdChange={this.handleOnAccountIdChange}
                onOrganisatieTypeChange={this.handleOnOrganisatieTypeChange}
                onSearch={this.handleOnSearch}
                error={this.state.error}
            />
        );
    }
}

SupportSpoVlaMedewerkerPage.propTypes = {
    loadLayout: PropTypes.func
};

function mapStateToProps(state, ownProps) {
    return {
    };
}

function mapDispatchToProps(dispatch, ownProps) {
    return {
        loadLayout: bindActionCreators(layoutActions.loadSupportSpoVlaMedewerkerLayout, dispatch),
        throwException: bindActionCreators(throwException, dispatch)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(SupportSpoVlaMedewerkerPage);
